import { useState } from "react";
import { View, TextInput, Pressable, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { useTheme } from "@/hooks/useTheme";
import type { SearchConfig } from "./types";
import { HEADER } from "@/components/Header/constants";

type SearchZoneProps = {
  config: SearchConfig;
};

export function SearchZone({ config }: SearchZoneProps) {
  const { colors } = useTheme();
  const [focused, setFocused] = useState(false);

  // Use controlled value if provided, otherwise manage internally
  const isControlled = config.value !== undefined;
  const [internalValue, setInternalValue] = useState("");
  const value = isControlled ? config.value : internalValue;

  const handleChangeText = (text: string) => {
    if (!isControlled) {
      setInternalValue(text);
    }
    config.onChangeText?.(text);
  };

  const handleClear = () => {
    if (!isControlled) {
      setInternalValue("");
    }
    config.onChangeText?.("");
  };

  return (
    <View
      style={[
        styles.container,
        {
          borderColor: focused ? colors.primary : colors.border,
          backgroundColor: colors.backgroundSecondary,
        },
        focused && styles.focused,
      ]}
    >
      <MaterialCommunityIcons name="magnify" size={18} color={focused ? colors.primary : colors.textSecondary} />
      <TextInput
        style={[styles.input, { color: colors.text }]}
        placeholder={config.placeholder}
        placeholderTextColor={colors.placeholder}
        value={value}
        onChangeText={handleChangeText}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      {value && value.length > 0 ? (
        <Pressable onPress={handleClear}>
          <MaterialCommunityIcons name="close-circle" size={16} color={colors.textSecondary} />
        </Pressable>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderWidth: StyleSheet.hairlineWidth,
    borderRadius: HEADER.RADIUS,
    paddingHorizontal: 10,
    height: HEADER.HEIGHT,
    minWidth: 200,
    maxWidth: 360,
  },
  focused: {
    minWidth: 320,
  },
  input: {
    flex: 1,
    fontSize: HEADER.FONT_SIZE,
    // @ts-ignore - web-specific style
    outlineStyle: "none",
  },
});
